import script from "./LeaderProjectFormStep3.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectFormStep3.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectFormStep3.vue?vue&type=style&index=0&id=4f6b259a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f6b259a"]])

export default __exports__